import * as amplitude from '@amplitude/analytics-browser';
import { AnalyticsEvent } from 'app/analytics/config';
import { snakecasedData } from 'shared_DEPRECATED/utils/object';
import { isProdEnv } from 'utils';

export const sendAmplitudeEvent = ({
  event,
  data,
}: {
  event: AnalyticsEvent;
  data: Record<string, string | number>;
}) => {
  amplitude.track({
    event_type: event,
    event_properties: data,
  });
};

export const sendAnalyticsEvent = ({
  event,
  data,
}: {
  event: AnalyticsEvent;
  data?: Record<string, string | number | boolean>;
}) => {
  if (!isProdEnv()) {
    return;
  }

  sendAmplitudeEvent({ event, data: snakecasedData(data) });
};
